export enum RepairPartStatusEnum {
    Installed = 'Installed',
    Removed = 'Removed',
    Deleted = 'Deleted'
}
